(function($){

    window.Application.Donate = {
        ui: {
            container: '.js-donate',
            nav: '.js-donate__nav',
            alternativeContent: '.js-donate__alternative-content',
            toggleContent: '.js-donate__toggle-content',
            radioToggle: '.js-donate__radio-toggle',
            radioToggleContent: '.js-donate__radio-toggle-content',
        },
        url: {
            theme: null,
            submit: null,
            logout: null,
        },
        ready: function () {

            var self = this;

            if (!$(this.ui.container).length){
                return;
            }

            // children
            this.StickySizing.ready(this);

            // toggle checkbox contents
            $(document).on('change', this.ui.radioToggle, function(){
                self.update($(this));
            });

            // toggle alternative contents
            $(this.ui.toggleContent).click(function(e){
                e.preventDefault();
                // toggle links
                $(self.ui.toggleContent).removeClass('active')
                    .filter('[data-content-id="' + $(this).attr('data-content-id')  + '"]').addClass('active');
                // content
                $(self.ui.alternativeContent).removeClass('active')
                    .filter('[data-content-id="' + $(this).attr('data-content-id')  + '"]').addClass('active');
            });

            // init
            $(this.ui.radioToggle).each(function(){
                self.update($(this));
            });
            $(this.ui.container).addClass('ready');

        },
        update: function($input){

            var self = this;

            var name = $input.attr('name');
            var $radios = $(this.ui.radioToggle).filter('[name="' + name + '"]');
            // switch all contents off, except for the active one
            $radios.each(function(){
                var $content = $(self.ui.radioToggleContent)
                    .filter('[data-content-id="' + $(this).attr('data-content-id')  + '"]');
                if ($(this).is(':checked')){
                    $content.addClass('active')
                }else{
                    $content.removeClass('active')
                }
            });

            // update size
            setTimeout(function(){
                self.StickySizing.update();
            }, 20);

        },
        StickySizing: {
            ui:{
                track: '.js-donate__sticky-track',
                form: '.js-donate__sticky-form',
            },
            donate: null,
            ready: function(donate){

                this.donate = donate;

                this.update();
                $(window).on('resize', this.update.bind(this));

            },
            update: function (){

                var $container = $(this.donate.ui.container);
                var $form = $(this.ui.form);
                var $track = $(this.ui.track);

                $container.css('min-height', $form.outerHeight(true) + 'px');
                $track.css('height', $container.height() + 'px');

                if($container.hasClass('s-donate--full-image')){
                    $container.css('height', $form.outerHeight(true) + 'px');
                }

            }
        }
    };

})(jQuery);